import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Header from "../Components/Header";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import axios from "../axiosInstance";
import Footer from "../Components/Footer";
import PageTitle from "../Components/PageTitle";
import AcademicCalendarBanner from "../assets/AcademicCalendar.png";

const AcademicCalendar = () => {
  const [calendarData, setCalendarData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCalendarData = async () => {
      try {
        const response = await axios.get("/api/v1/academic-calendar/get");
        setCalendarData(response?.data?.academicCalendar);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCalendarData();
  }, []);

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  return (
    <>
      <Navbar />
      <PageTitle
        title="Academic Calendar - Shree Mangalam School"
        description="View the complete academic calendar of Shree Mangalam School including session schedules, exam dates, holidays, and important academic events."
        url="/academic-calendar"
        keywords="academic calendar, school calendar, exam schedule, Shree Manglam calendar, RIMC school session dates, holiday list"
      />

      <Header image={AcademicCalendarBanner} alt={"Academic Calendar Banner"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            fontSize: "30px",
            color: "#065A79",
            fontWeight: "bold",
            mb: 3,
          }}
          gutterBottom
        >
          Academic Calendar
        </Typography>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <CircularProgress />
          </div>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <TableContainer component={Paper} elevation={3}>
            <Table sx={{ minWidth: 650 }} aria-label="academic calendar table">
              <TableHead sx={{ backgroundColor: "#065A79" }}>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#fff",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                    }}
                  >
                    S.No.
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#fff",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#fff",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#fff",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                    }}
                  >
                    Calendar
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {calendarData?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        width: "8%",
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      sx={{
                        // width: "15%",
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                      }}
                    >
                      {item?.date}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                      }}
                    >
                      {item?.name}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                      }}
                      // dangerouslySetInnerHTML={{ __html: item.event }}
                    >
                      {stripHtml(item?.event)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
      <Footer />
    </>
  );
};

export default AcademicCalendar;
